module.exports = __webpack_public_path__ + "img/utilityhydrant_driving.148a7c65.svg";